import React from 'react';
import IntroduceCompany from './introduceCompany';
import IntroduceManager from './introduceManager';

const SinorPremiumPage:React.FC = () => (
  <div>
    <IntroduceCompany />
    <IntroduceManager />
  </div>
);

export default SinorPremiumPage;
